/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Filter_BranchInputs */

const en_case_filter_branch = /** @type {(inputs: Case_Filter_BranchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch`)
};

const pt_br2_case_filter_branch = /** @type {(inputs: Case_Filter_BranchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filial`)
};

/**
* | output |
* | --- |
* | "Branch" |
*
* @param {Case_Filter_BranchInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_filter_branch = /** @type {((inputs?: Case_Filter_BranchInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Filter_BranchInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_filter_branch(inputs)
	return pt_br2_case_filter_branch(inputs)
});